import {ApplicationAuthConfig, FrontendAppConfigKey, FrontendAppSwitch} from '@lifeislife/lifeislife-domain';
import {CustomerFrontAppSwitches} from '../domain/customer-front-app-switches';

export const environment = {
  production: true,
  defaultSwitches: {
    [FrontendAppSwitch.front_dev_banner]: false,
    [FrontendAppSwitch.front_dev_debug]: false,
    [FrontendAppSwitch.front_error_report]: true,
    [CustomerFrontAppSwitches.pension_breackdown_per_contact]: true,
  },
  defaultConfig: {
    [FrontendAppConfigKey.app_name]: 'My LifeisLife Dev',
    [FrontendAppConfigKey.app_configKey]: 'customer.front',
    [FrontendAppConfigKey.lifeislife_ws_uri]: 'https://api.lifeislifedev.valuya.be/lifeislife-ws',
  },
  // Issuer, REDIRECT, clientId, silentRefresh uri are overridden at runtime.
  authConfig: {
    responseType: 'code',
    scope: 'openid',
    oidc: true,
    clearHashAfterLogin: true,
    showDebugInformation: true,
    silentRefreshTimeout: 500,
    timeoutFactor: 0.8,
    sessionChecksEnabled: false,
  } as ApplicationAuthConfig,
};
